import { render, staticRenderFns } from "./thresholdSet.vue?vue&type=template&id=c9083e2a&scoped=true"
import script from "./thresholdSet.vue?vue&type=script&lang=js"
export * from "./thresholdSet.vue?vue&type=script&lang=js"
import style0 from "./thresholdSet.vue?vue&type=style&index=0&id=c9083e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9083e2a",
  null
  
)

export default component.exports